module.exports = __webpack_public_path__ + "static/img/02_04_distortion.7151cd3.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/bias-fx2/sound-page/02_04_distortion.png
// module id = sNr/
// module chunks = 12